import { defineComponent, inject, ref, watch } from '@vue/composition-api';
import WidgetMenu from 'components/DataWidgets/WidgetMenu/WidgetMenu.vue';
import WidgetFrame from 'components/widgets/WidgetFrame/WidgetFrame.vue';
import icon from 'assets/img/dashboards/dash-summary.svg';
import { BfButton, BfSpinner } from 'components/Butterfly';
import Query from 'src/api/query';
import { mergeDashboardFiltersWithBotanicQuery } from "src/utils/query";
export default defineComponent({
    components: {
        WidgetFrame,
        WidgetMenu,
        BfSpinner,
        BfButton
    },
    props: {
        devMode: { type: Boolean, required: false, default: false },
        /** Add a skeleton mask (used when reloading state between dashboards) */
        masked: { type: Boolean, required: false, default: false },
        dashboardId: { type: Number, required: false, default: null },
        projectId: { type: Number, required: false, default: null },
        currentSite: { type: Object, default: () => null, required: false },
        currentProject: { type: Object, default: () => null, required: false },
        currentAnalysis: { type: Object, default: () => null, required: false },
        query: { type: Object, required: false, default: null },
        mergedFilters: { type: Array, default: () => null, required: false },
        savedQueries: { type: Array, default: () => null, required: false },
        themeName: { type: String, required: false, default: null },
    },
    setup(props, { emit }) {
        const analytics = inject('analytics');
        const root = ref(null);
        const wrapper = ref(null);
        const isLoading = ref(false);
        const summary = ref('');
        const sampleVerbatims = ref([]);
        const width = ref(300);
        const refresh = () => {
            window.location.reload();
        };
        const setChartDimensions = (w) => {
            width.value = w;
        };
        const contact = () => {
            try {
                window.Intercom('show');
            }
            catch {
                console.warn('intercom show failed');
            }
        };
        const reload = () => {
            getSummary();
        };
        const getSummary = async () => {
            try {
                isLoading.value = true;
                analytics?.track.dashboard.tellAStory(props.dashboardId);
                const themeName = props.themeName;
                const summary_type = 'paragraph';
                const summaryResult = await Query.generateSummary(props.projectId, props.currentSite.chrysalis_url, props.currentProject.chrysalis_ref, props.currentAnalysis.topic_framework_id, mergeDashboardFiltersWithBotanicQuery(props.query, props.mergedFilters), props.savedQueries, summary_type, themeName, 2);
                if (summaryResult && summaryResult.payload) {
                    summary.value = summaryResult.payload[0].summary;
                    sampleVerbatims.value = summaryResult.payload[0].sample_verbatims;
                }
                else {
                    throw new Error(`Failed to get summary data`);
                }
            }
            catch (e) {
                //throw new Error(`Error ${e}`)
                console.warn(`Error ${e}`);
            }
            finally {
                isLoading.value = false;
            }
        };
        watch(() => props.mergedFilters, () => {
            summary.value = '';
        }, {
            deep: true,
        });
        return {
            icon,
            root,
            refresh,
            contact,
            reload,
            isLoading,
            getSummary,
            summary,
            sampleVerbatims,
            setChartDimensions,
            width,
        };
    },
});
